export enum BuilderStage {
  BOOKING = -2,
  CHARGING = -3,
  AMENDED = -4,
  CONVICTION = -5,
  SENTENCING = -6,
}
